import { db } from "../App.js";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";

//saves flagData object under /flags/UUID with UUID being a randomly generated UUID
export async function writeFlagData(flagData) {
  //generates UUID.
  const uuid = uuidv4();

  await setDoc(doc(db, "flags", uuid), flagData);
  return uuid;
}

export async function getFlagData(uuid) {
  const snapshot = await getDoc(doc(db, "flags", uuid));
  if (snapshot.exists()) {
    return snapshot.data();
  } else {
    return null;
  }
}
